export const PageCounterRoutes = {
    countUploadedDocument: "/v1/clients/projects/{projectId}/page-counter",
} as const;
